import { render, staticRenderFns } from "./BaseSetPolygon.vue?vue&type=template&id=00536862"
import script from "./BaseSetPolygon.vue?vue&type=script&lang=js"
export * from "./BaseSetPolygon.vue?vue&type=script&lang=js"
import style0 from "./BaseSetPolygon.vue?vue&type=style&index=0&id=00536862&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports